// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: Arial, sans-serif;
}

.title h3{
    background-color: #6699cc;
    color: #ffffff;
    padding: 10px;
    text-align: left;
  }

.dropdown-container {
    display: flex;
    gap: 20px;
    align-items: center;
    margin-top: 20px;
}

.dropdown-container label {
    margin-right: 10px;
}

#doa-category, #doa-types {
    width: 300px;
    height: 32px;
}

#orderby {
    width: 100px;
}
.color{
    background-color: #6699cc;
    color: white;
    width: 1140px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
.button-container {
    display: flex;
    justify-content: center;
    gap: 20px;
    margin-top: 20px;
}

.employee-details-box {
    border: 1px solid #ccc;
    padding: 20px;
    border-radius: 5px;
    width: 100%;
  }
  
  .center-content {
    margin: auto !important;
    text-align: center;
}

  label {
    margin-bottom: 5px;
    margin-right: 10px;
  }

  .form-item {
    display: flex;
    align-items: center;
}

.form-item input {
    margin-left: 10px;
}

table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

th, td {
    border: 1px solid white;
    text-align: center;
    padding: 8px;
}

table th {
    background-color: #0b2d71;
    color: white;
    font-weight: bold;
}

td a {
    color: blue;
    text-decoration: none; 
}

td a:hover {
    text-decoration: underline;
}

.clickable-input {
    border: none;
    background: none;
    color: blue;
    text-decoration: underline;
    cursor: pointer;
  }
.bordered-container {
    border: 1px solid #d3d3d3; 
    padding: 20px;
    max-width: 100%;
    margin: 3% 0%;
    border-radius: 1px;
    padding-bottom: 1%;
  }
  .shift-left {
    margin-left: -88px;
  }
 
  .error-message {
    color: red;
    font-weight: bold;
  }`, "",{"version":3,"sources":["webpack://./src/app/modules/delegationofauthority/bydirectreport/bydirectreport.component.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,gBAAgB;EAClB;;AAEF;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;AACF;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,kBAAkB;AACtB;;EAEE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,0BAA0B;IAC1B,eAAe;EACjB;AACF;IACI,yBAAyB;IACzB,aAAa;IACb,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB","sourcesContent":["body {\n    font-family: Arial, sans-serif;\n}\n\n.title h3{\n    background-color: #6699cc;\n    color: #ffffff;\n    padding: 10px;\n    text-align: left;\n  }\n\n.dropdown-container {\n    display: flex;\n    gap: 20px;\n    align-items: center;\n    margin-top: 20px;\n}\n\n.dropdown-container label {\n    margin-right: 10px;\n}\n\n#doa-category, #doa-types {\n    width: 300px;\n    height: 32px;\n}\n\n#orderby {\n    width: 100px;\n}\n.color{\n    background-color: #6699cc;\n    color: white;\n    width: 1140px;\n    height: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n.button-container {\n    display: flex;\n    justify-content: center;\n    gap: 20px;\n    margin-top: 20px;\n}\n\n.employee-details-box {\n    border: 1px solid #ccc;\n    padding: 20px;\n    border-radius: 5px;\n    width: 100%;\n  }\n  \n  .center-content {\n    margin: auto !important;\n    text-align: center;\n}\n\n  label {\n    margin-bottom: 5px;\n    margin-right: 10px;\n  }\n\n  .form-item {\n    display: flex;\n    align-items: center;\n}\n\n.form-item input {\n    margin-left: 10px;\n}\n\ntable {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n}\n\nth, td {\n    border: 1px solid white;\n    text-align: center;\n    padding: 8px;\n}\n\ntable th {\n    background-color: #0b2d71;\n    color: white;\n    font-weight: bold;\n}\n\ntd a {\n    color: blue;\n    text-decoration: none; \n}\n\ntd a:hover {\n    text-decoration: underline;\n}\n\n.clickable-input {\n    border: none;\n    background: none;\n    color: blue;\n    text-decoration: underline;\n    cursor: pointer;\n  }\n.bordered-container {\n    border: 1px solid #d3d3d3; \n    padding: 20px;\n    max-width: 100%;\n    margin: 3% 0%;\n    border-radius: 1px;\n    padding-bottom: 1%;\n  }\n  .shift-left {\n    margin-left: -88px;\n  }\n \n  .error-message {\n    color: red;\n    font-weight: bold;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
